var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaregiverBurden(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_4907)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.95 45.1252C106.95 30.1435 94.8947 18.0002 80 18.0002C65.1053 18.0002 53.05 30.1435 53.05 45.1252C53.05 60.1167 65.1053 72.2502 80 72.2502C94.8947 72.2502 106.95 60.1167 106.95 45.1252ZM137.75 80.6542L123.24 100.102C120.978 103.153 116.647 103.686 113.712 101.264C111.185 99.1573 110.535 95.2823 112.244 92.6666L117.393 83.9963C119.487 80.4846 118.524 75.9557 115.203 73.6307C111.859 71.3057 107.311 71.9838 105.001 75.1565L93.5953 89.2276C89.7934 93.8292 87.7 100.005 87.7 106.181V134.25C87.7 138.537 91.1409 142 95.4 142H118.5C120.834 142 123.048 140.935 124.516 138.876L153.626 102.475C155.81 99.7143 157 96.2995 157 92.7877V42.9698C157 37.8378 152.69 33.2823 147.375 33.2823C142.06 33.2823 137.75 37.8378 137.75 42.9698V80.6542ZM3 43.1877V92.7877C3 96.2995 4.17906 99.7143 6.58531 102.475L35.7009 138.876C36.9522 140.935 39.1659 142 41.5 142H64.6C68.8591 142 72.3 138.537 72.3 134.25V106.181C72.3 100.005 70.2066 93.8292 66.4047 89.2276L55.2156 75.1565C52.6891 71.9838 48.1412 71.3057 44.7966 73.6307C41.4759 75.9557 40.5134 80.4846 42.6069 83.9963L47.9728 92.6666C49.4647 95.2823 48.815 99.1573 46.2644 101.264C43.3528 103.686 39.0216 103.153 36.7597 100.102L22.25 80.6542V43.1877C22.25 37.8378 17.9428 33.5002 12.625 33.5002C7.30719 33.5002 3 37.8378 3 43.1877Z",
    fill: "#E69A8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.144 45.1252C106.144 30.1435 94.089 18.0002 79.1943 18.0002C64.2996 18.0002 52.2443 30.1435 52.2443 45.1252C52.2443 60.1167 64.2996 72.2502 79.1943 72.2502C94.089 72.2502 106.144 60.1167 106.144 45.1252Z",
    fill: "#7A51AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_4907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 124,
    fill: "white",
    transform: "matrix(-1 0 0 1 157 18.0002)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiverBurden);
export default __webpack_public_path__ + "static/media/caregiverBurden.d97ee31e1b926cfc4f972563d1bae2a7.svg";
export { ForwardRef as ReactComponent };